import MenuDesktop from '../components/menuDesktop';
import anchorTool from '../components/anchorTool';

export default {
    init() {
        // JavaScript to be fired on all pages

        //Tracciamenti CF7_CONTATTIPROD_ID
        document.addEventListener('wpcf7submit', function(event) {
            // event.detail.inputs[5].value = 'TESTTTTTT';
            // console.log(event.detail.inputs[5]);
          //     console.log('Listener per wpcf7submit attivato', php_vars.formId);
          //       if (event.detail.contactFormId == window.ciao) {
              if (event.detail.contactFormId == php_vars.formId) {
                window.dataLayer.push({
                  'event': 'GFTrackEvent',
                  'GFTrackCategory': 'form_prodotti',
                  'GFTrackAction': 'click',
                  'GFTrackLabel':'form prodotti',

                });
            }
          });
        // Hamburger
        $('.hamburger-button').click(function () {
            $('.wrap-mobile').fadeIn();
            $('body').addClass('no-scroll');
        });
        $('#close-menu').click(function () {
            $('.wrap-mobile').fadeOut();
            $('body').removeClass('no-scroll');
        });


        //MENU MOBILE
        $('.nav-menu-mobile a.has-child').click(function (e) {

            e.preventDefault();

            $('.nav-menu-mobile .title-col-sub-menu.active').removeClass('active');
            $('.nav-menu-mobile .wrap-child').slideUp();

            let itemActive = $('.nav-menu-mobile a.has-child.active');
            let subMenuActive = $('.nav-menu-mobile a.has-child.active').parent().find('.wrap-sub-menu');

            let currentItem = $(this);
            let currentSubMenu = $(this).parent().find('.wrap-sub-menu');

            if (currentItem.hasClass('active')) {
                currentItem.removeClass('active');
                currentSubMenu.slideUp();
            } else {
                itemActive.removeClass('active');
                subMenuActive.slideUp();
                currentItem.addClass('active');
                currentSubMenu.slideDown();
            }

        });


        //COLONNA MENU MOBILE
        $('.nav-menu-mobile .title-col-sub-menu').click(function (e) {

            e.preventDefault();

            //console.log($(this).parent());

            let itemActive = $('.nav-menu-mobile .title-col-sub-menu.active');
            let itemActiveCol = $('.nav-menu-mobile .title-col-sub-menu.active').attr('data-col');
            let subMenuActive = $('.nav-menu-mobile .title-col-sub-menu.active').parent().find('.wrap-child[data-parent-col="' + itemActiveCol + '"]');

            let currentItem = $(this);
            let currentCol = $(this).attr('data-col');
            let currentSubMenu = $(this).parent().find('.wrap-child[data-parent-col="' + currentCol + '"]');

            if (currentItem.hasClass('active')) {
                currentItem.removeClass('active');
                currentSubMenu.slideUp();
            } else {
                itemActive.removeClass('active');
                subMenuActive.slideUp();
                currentItem.addClass('active');
                currentSubMenu.slideDown();
            }

        });


        let menuContainer = $('.nav-menu-desktop');
        new MenuDesktop(menuContainer);

        // Slider
        $('.slider-full-screen .owl-carousel').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
        });

        $('.slider-elementi-multipli .owl-carousel').each(function () {

            //console.log($(this));

            $(this).owlCarousel({
                items: 3,
                loop: false,
                margin: 30,
                nav: false,
                dots: true,
                dotsContainer: $(this).parents('.slider-elementi-multipli').find('.dots-carousel'),
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                },
            });

        });

        $('.slider-video').each(function () {

            $(this).owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: true,
                dots: false,

                onTranslate: function () {

                    var currentSlide, player, command;

                    currentSlide = $('.owl-item.active');

                    player = currentSlide.find('.embed-responsive.embed-responsive-16by9 iframe').get(0);

                    command = {
                        'event': 'command',
                        'func': 'pauseVideo',
                    };

                    if (player !== undefined) {
                        player.contentWindow.postMessage(JSON.stringify(command), '*');

                    }

                },

            });

        });

        // Product carousel
        $('.info-product .owl-carousel').owlCarousel({
            loop: false,
            margin: 0,
            nav: true,
            dots: false,
            items: 1,
        });

        // Timeline
        $('.timeline .owl-carousel').each(function () {

            //console.log($(this));

            $(this).owlCarousel({
                //items: 3,
                loop: false,
                margin: 50,
                nav: false,
                dots: true,
                dotsContainer: $(this).parents('.timeline').find('.dots-carousel'),
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                },
            });

        });

        // Search
        $('#search-button').click(function () {
            $('.search-fullscreen').fadeIn();
            $('.input-search').focus();
        });
        $('#close-search').click(function () {
            $('.search-fullscreen').fadeOut();
        });


        //ANCHOR TOOL
        let anchorToolElm = $('.anchorTool');
        let myHash = window.location.hash;
        if (anchorToolElm.length) {
            let anchorComponent = new anchorTool(jQuery('.anchorTool'));
            if (myHash !== '') {
                setTimeout(function () {
                    anchorComponent.scrollToBox(myHash.replace('#', ''));
                }, 1000);
            }
        } else {
            let $root = $('html, body');
            $('a[href^="#"]').click(function (event) {
                event.preventDefault();
                let target = $(this.hash);
                if (target.length) {
                    let offsetAdjust = parseInt($('header').height()) + 10;
                    $root.animate({
                        scrollTop: target.offset().top - offsetAdjust,
                    }, 500);
                }
            });
        }

        document.addEventListener('wpcf7mailsent', function (e) {

            let frm = $(e.target);

            //console.log(frm);

            if(frm.hasClass('cf7-newsletter')){

                window.gtag('event', 'click', {
                    'event_category': 'form',
                    'event_label': 'iscrizione newsletter',
                });

            } else {

                let wrapForm = frm.parents('.blocco-form');

                if(wrapForm.hasClass('cf7-contatti')) {

                    window.gtag('event', 'click', {
                        'event_category': 'form',
                        'event_label': 'form contatti - ' + location.href,
                    });
                }

            }

        });

        /*
        window.cookieconsent.initialise({
            'palette': {
                'popup': {
                    'background': '#CF1724',
                },
                'button': {
                    'background': '#212121',
                },
            },
            'position': 'bottom-right',
            'content': {
                'dismiss': 'OK',
                'message': window.textBannerPrivacy,
                'link': window.linkBannerPrivacyLabel,
                'href': window.linkBannerPrivacyUrl,
            },
        });
        */

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js